import axios from '@/shared/utils/axios-init';
import { gaussRound } from '@/shared/utils/helpers/gaussRound';


const initialState = {
  buyOrdersData: [],
  sellOrdersData: [],
  buyOrderItem: {
    price: 0,
    amount: 0,
    summ: 0,
    fee: 0,
    feePercent: 0,
    total: 0,
    defaultPrice: 0,
    index: null,
  },
  sellOrderItem: {
    price: 0,
    amount: 0,
    summ: 0,
    fee: 0,
    feePercent: 0,
    total: 0,
    defaultPrice: 0,
    index: null,
  },
  fee: 0,
  marketSellFee: 0,
  marketBuyFee: 0,
  buyMinPrice: 0,
  sellMinPrice: 0,
  ordersBuyVolume: 0,
  ordersSellVolume: 0,
  marketBuyState: false,
  marketSellState: false,
};

const getters = {
  getBuyOrdersData(state) {
    return state.buyOrdersData;
  },
  getSellOrdersData(state) {
    return state.sellOrdersData;
  },
  getBuyOrderItem(state) {
    return state.buyOrderItem;
  },
  getSellOrderItem(state) {
    return state.sellOrderItem;
  },

  getMarketBuyFee(state) {
    return state.marketBuyFee;
  },

  getMarketSellFee(state) {
    return state.marketSellFee;
  },

  getOrdersBuyVolume: state => state.ordersBuyVolume,
  getOrdersSellVolume: state => state.ordersSellVolume,

  getFee: state => state.fee,
  getBuyMinPrice: state => state.buyMinPrice,
  getSellMinPrice: state => state.sellMinPrice,
  getMarketBuyState: state => state.marketBuyState,
  getMarketSellState: state => state.marketSellState,
};

const mutations = {
  setBuyOrdersData(state, orders) {
    state.buyOrdersData = [];
    state.buyOrdersData = orders;
  },
  setSellOrdersData(state, orders) {
    state.sellOrdersData = [];
    state.sellOrdersData = orders;
  },

  setOrdersBuyVolume(state, volume) {
    state.ordersBuyVolume = volume;
  },
  setOrdersSellVolume(state, volume) {
    state.ordersSellVolume = volume;
  },
  setMarketBuyState(state, marketState) {
    state.marketBuyState = marketState;
  },
  setMarketSellState(state, marketState) {
    state.marketSellState = marketState;
  },
  setFee(state, data) {
    state.fee = Number(data);
  },
  setMarketSellFee(state, data) {
    state.marketSellFee = Number(data);
  },
  setMarketBuyFee(state, data) {
    state.marketBuyFee = Number(data);
  },
  setBuyMinPrice(state) {
    if (state.buyOrdersData.length) {
      state.buyMinPrice = +state.buyOrdersData[0].price;
    } else {
      state.buyMinPrice = +(0).toFixed(8);
    }
  },
  setSellMinPrice(state) {
    if (state.sellOrdersData.length) {
      state.sellMinPrice = +state.sellOrdersData[0].price;
    } else {
      state.sellMinPrice = +(0).toFixed(8);
    }
  },
  setOrderItem(state, itemData) {
    let ordersData;
    let feePercent;

    if (itemData.type === 'buy') {
      feePercent = state.marketBuyState ? state.marketBuyFee : state.fee;
      ordersData = state.buyOrdersData;
    } else {
      feePercent = state.marketSellState ? state.marketSellFee : state.fee;
      ordersData = state.sellOrdersData;
    }

    const item = {
      price: (0).toFixed(8),
      amount: (0).toFixed(8),
      summ: (0).toFixed(8),
      fee: (0).toFixed(8),
      defaultPrice: (0).toFixed(8),
      total: (0).toFixed(8),
    };

    // for empty orders list
    //----------------------------------
    if (ordersData[itemData.index] === undefined) {
      item.amount = gaussRound(1, 8).toFixed(8);

      item.price = gaussRound(+itemData.rates.sellRate, 8).toFixed(8);
      item.defaultPrice = gaussRound(+itemData.rates.sellRate, 8).toFixed(8);

      item.summ = gaussRound(item.price * item.amount, 8).toFixed(8);
      item.fee = gaussRound((item.summ * feePercent) / 100, 8).toFixed(8);

      if (itemData.type === 'buy') {
        item.total = gaussRound(+item.summ - +item.fee, 8).toFixed(8);
      } else {
        item.total = gaussRound(+item.summ + +item.fee, 8).toFixed(8);
      }
      /* eslint-disable */
      (itemData.type === 'buy') ? state.buyOrderItem = item : state.sellOrderItem = item;
      return;
    }

    // For first init
    //----------------------------------
    if (itemData.firstInit) {
      item.price = gaussRound(ordersData[0].price, 8).toFixed(8);
      item.defaultPrice = gaussRound(ordersData[0].price, 8).toFixed(8);
      item.amount = gaussRound(1, 8).toFixed(8);
      item.summ = gaussRound(item.price * item.amount, 8).toFixed(8);
      item.fee = gaussRound((item.summ * feePercent) / 100, 8).toFixed(8);

      if (itemData.type === 'buy') {
        item.total = gaussRound(+item.summ - +item.fee, 8).toFixed(8);
      } else {
        item.total = gaussRound(+item.summ + +item.fee, 8).toFixed(8);
      }

      /* eslint-disable */
      (itemData.type === 'buy') ? state.buyOrderItem = item : state.sellOrderItem = item;
      return;
    }


    // When click on tables element
    //----------------------------------
    item.index = itemData.index,
    item.price = gaussRound(+ordersData[itemData.index].price, 8).toFixed(8);
    item.defaultPrice = gaussRound(+ordersData[itemData.index].price, 8).toFixed(8);
    item.amount = gaussRound(+ordersData[itemData.index].open_amount, 8).toFixed(8);
    item.summ = gaussRound(+item.price * +item.amount, 8).toFixed(8);

    item.fee = gaussRound((+item.summ * feePercent) / 100, 8).toFixed(8);

    if (itemData.type === 'buy') {
      item.total = gaussRound(+item.summ - +item.fee, 8).toFixed(8);
    } else {
      item.total = gaussRound(+item.summ + +item.fee, 8).toFixed(8);
    }

    /* eslint-disable */
    (itemData.type === 'buy') ? state.buyOrderItem = item : state.sellOrderItem = item;
  },

  setBalanceAmount(state, data) {
    let item;
    let feePercent;
    if (data.typeOfCalc === 'buy') {
      feePercent = state.marketBuyState ? state.marketBuyFee : state.fee;
      item = state.sellOrderItem;
      item.total = gaussRound(+data.summ, 8).toFixed(8);
      item.fee = gaussRound((item.total * feePercent) / 100, 8).toFixed(8);
      item.summ = gaussRound(item.total - item.fee, 8).toFixed(8);
      item.amount = gaussRound(item.summ / +item.price, 8).toFixed(8);
    } else {
      feePercent = state.marketSellState ? state.marketSellFee : state.fee;
      item = state.buyOrderItem;
      item.amount = gaussRound(data.summ, 8).toFixed(8);
      item.summ = gaussRound(+item.amount * +item.price, 8).toFixed(8);
      item.fee = gaussRound((+item.summ * feePercent) / 100, 8).toFixed(8);
      item.total = gaussRound(+item.summ - +item.fee, 8).toFixed(8);
    }
  },

  updatedAmount(state, data) {
    let item;
    let feePercent;

    if (data.typeOfCalc === 'buy') {
      feePercent = state.marketBuyState ? state.marketBuyFee : state.fee;
      item = state.sellOrderItem;
    } else {
      feePercent = state.marketSellState ? state.marketSellFee : state.fee;
      item = state.buyOrderItem;
    }

    item.amount = data.value;

    // check if summ bigger then max safe value
    //-------------------------------------------
    let summ = (+item.amount * +item.price).toFixed(8)
    if (summ > Number.MAX_SAFE_INTEGER) {
      item.summ = `${Number.MAX_SAFE_INTEGER.toFixed(8)}`;
    } else {
      item.summ = summ;
    }

    item.fee = gaussRound((+item.summ * feePercent) / 100, 8).toFixed(8);
    if (data.typeOfCalc === 'buy') {
      item.total = gaussRound(+item.summ + +item.fee, 8).toFixed(8);
    } else {
      item.total = gaussRound(+item.summ - +item.fee, 8).toFixed(8);
    }
  },

  updatedPrice(state, data) {
    let item;
    let feePercent;

    if (data.typeOfCalc === 'buy') {
      feePercent = state.marketBuyState ? state.marketBuyFee : state.fee;
      item = state.sellOrderItem;
    } else {
      feePercent = state.marketSellState ? state.marketSellFee : state.fee;
      item = state.buyOrderItem;
    }

    item.price = data.value;

    // check if summ bigger then max safe value
    //-------------------------------------------
    let summ = (+item.amount * +item.price).toFixed(8)
    if (summ > Number.MAX_SAFE_INTEGER) {
      item.summ = `${Number.MAX_SAFE_INTEGER.toFixed(8)}`;
    } else {
      item.summ = summ;
    }

    item.fee = gaussRound((+item.summ * feePercent) / 100, 8).toFixed(8);
    if (data.typeOfCalc === 'buy') {
      item.total = gaussRound(+item.summ + +item.fee, 8).toFixed(8);
    } else {
      item.total = gaussRound(+item.summ - +item.fee, 8).toFixed(8);
    }
  },
  updatedSumm(state, data) {
    let item;
    let feePercent;

    if (data.typeOfCalc === 'buy') {
      feePercent = state.marketBuyState ? state.marketBuyFee : state.fee;
      item = state.sellOrderItem;
    } else {
      feePercent = state.marketSellState ? state.marketSellFee : state.fee;
      item = state.buyOrderItem;
    }

    item.summ = data.value;
    item.amount = (+item.summ / +item.price).toFixed(8);
    item.fee = gaussRound((+item.summ * feePercent) / 100, 8).toFixed(8);
    if (data.typeOfCalc === 'buy') {
      item.total = gaussRound(+item.summ + +item.fee, 8).toFixed(8);
    } else {
      item.total = gaussRound(+item.summ - +item.fee, 8).toFixed(8);
    }
  },
};

const actions = {
  async makeDeal({ commit, dispatch, rootState }, order) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/orders/create', order, { headers: { Authorization: `Bearer ${token}` } });
      const msg = data.data.msg;

      // updated Arrays
      commit('setBuyOrdersData', data.data.buy_orders.list);
      commit('setSellOrdersData', data.data.sell_orders.list);

      // volume
      commit('setOrdersBuyVolume', data.data.buy_orders.amount);
      commit('setOrdersSellVolume', data.data.sell_orders.amount);

      // message
      // dispatch('dashboard/calculator/successfulSnackbar', { state: true, msg }, { root: true });
      dispatch('dashboard/calculator/successfulDialog', { state: true, msg }, { root: true });

      dispatch('dashboard/finance/fetchFinanceData', null, { root: true });
      dispatch('dashboard/requests/fetchRequestsData', rootState.dashboard.market.currenciesPair, { root: true });
    } catch (error) {
      // dispatch('dashboard/calculator/successfulSnackbar', { state: true, msg: error.response.data.err }, { root: true });
      dispatch('dashboard/calculator/successfulDialog', { state: true, msg: error.response.data.err }, { root: true });
    }
  },

  async fetchOrdersList({ commit, dispatch, rootState }, currencies) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/orders', currencies, { headers: { Authorization: `Bearer ${token}` } });

      const buyOrders = data.data.buy_orders.list;
      const buyVolume = data.data.buy_orders.amount;
      const sellOrders = data.data.sell_orders.list;
      const sellVolume = data.data.sell_orders.amount;
      const timestamp = data.data.timestamp;

      // orders lists data
      commit('setBuyOrdersData', buyOrders);
      commit('setSellOrdersData', sellOrders);

      // need to get Rates before then we set orders item
      //---------------------------------------------------------
      await dispatch('dashboard/calculator/fetchCalculatorData', currencies, { root: true });

      // set Items
      commit('setOrderItem', {
        index: 0,
        firstInit: true,
        type: 'buy',
        rates: rootState.dashboard.calculator.rates
      });

      commit('setOrderItem', {
        index: 0,
        firstInit: true,
        type: 'sell',
        rates: rootState.dashboard.calculator.rates
      });

      // min price
      commit('setBuyMinPrice');
      commit('setSellMinPrice');

      // volume
      commit('setOrdersBuyVolume', buyVolume);
      commit('setOrdersSellVolume', sellVolume);

      // timestamp
      commit('dashboard/setTimestamp', timestamp, { root: true });
    } catch (error) {
      /* eslint-disable */
      console.log('Orders:', error);
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/modules/orders.js